const ch_TW = {
  header001: '軟體介紹',
  header002: '台灣雲管家問題',
  header003: '版本資訊',
  header004: '聯繫我們',
  header005: '功能說明',
  header006: '產品下載',
  title: '服務雲',
  title_detail: '用互聯網與企業溝通',
  title_intro: '僅適用於windows',
  button_download: '立即下載',
  button_download_zhupy: '下載服務雲組件',
  button_download_cloud: '下載服務雲管家',
  banner_list_item0101: '專屬專業',
  banner_list_item0102: '客服服務',
  banner_list_item0201: '實時簡易',
  banner_list_item0202: '案件管理',
  banner_list_item0301: '高效專業',
  banner_list_item0302: '連線精靈',
  banner_list_item0401: '豐富實用',
  banner_list_item0402: '資訊中心',
  banner_list_item0501: '海量可查',
  banner_list_item0502: '知識寶典',
  more: '更多功能',
  service: '專屬的客服服務',
  serviceText:
    '用互聯網技術打通企業與客服人員的溝通，資深的客服專員爲您提供專屬的客服服務。',
  submit: '實時案件提交',
  submitText:
    '實時在線提交案件，客服專員第一時間爲您服務，並可實時追蹤案件處理進度。',
  remote: '高效的連線精靈',
  remoteText: '客服專員使用高效的連線精靈為您遠端連線處理問題。',
  tools: '豐富的工具',
  toolsText:
    '官方提供工具，財務報表環境檢測、成本對帳、存貨對帳、效能排查等節能輕鬆解決。 ',
  knowledge: '海量的知識庫',
  knowledgeText:
    '海量的知識庫，影音和圖文詳細指導您解決月結、LRP、盤點、IT等常見問題。',
  detail:
    '專業團隊爲您打造更方便的服務應用，通知中心、智能運維、鼎新社區等更多功能即將推出,敬能期待',
  item01: '服務應用',
  item02: '通知中心',
  item03: '智慧運維',
  item04: '鼎新社區',
  caption: '鼎新服務雲管家',
  captionTw: '鼎新服務雲管家',
  headline: '用互聯網與企業溝通',
  newbie: '新手上路',
  cmp_handbook: '雲管家操作手冊',
  own_application: '雲管家應用',
  ver_info: '版本更新內容',
  ver_info_em: '當前暫無版本',
  ver_info_empty: '無版本更新內容',
  ver_info_add: '新增',
  ver_info_opt: '優化',
  ver_info_history: '歷史版本',
  copy_right_number:
    'Copyright © DATA SYSTEMS CO., LTD. All rights reserved.',
  copy_right: ' 鼎新數智股份有限公司',
  dl_tel: '客服電話',
  fix_tel: '固定電話',
  service_tel: '客服熱線',
  tech_tel: '技術支持熱線',
  not_detail01: '哎呀！迷路了吶...',
  not_detail02: '休息一下回到首頁吧',
  not_detail03: '回到首頁',
  common_detail_title01: '開啟雲管家，閃退或者已停止工作',
  common_detail_title02: '客戶註冊雲管家時，客服代號綁定錯誤，怎麼辦？',
  common_detail_title03: 'IM聊天查看圖片失敗，透明',
  common_detail_title04: '雲管家知識搜索視頻點播放黑屏，看不了怎麼辦？',
  common_detail_title05: '開啟雲管家沒有任何報錯，但是未自動更新到最新版本',
  common_detail_title06: '遠程接受之後崩潰，提示：已停止工作',
  common_detail_content01:
    '解決方案：1、添加相容模式並以管理員身份運行！2、上述方法無果後，查看用戶端.net framework版本是否為4.6 或者4.7。那麼請卸載高版本的.net，然後安裝4.0版本。若安裝如下報錯，請自行百度下載4.5版本安裝後即可解决此問題。',
  common_detail_content02:
    '退出雲管家--删除我的文件DigiwinSCPConfig資料夾下的SCP.desktop.shell.xml檔案（如下圖）--重新開啟雲管家--會出現客服代號綁定介面，重新綁定',
  common_detail_content03:
    '雲管家IM系統查看圖片默認驅動使用的是windows自帶的照片檢視器。最近wps陞級，會篡改OS默認圖片檢視器為wps看圖，才導致了IM聊天時查看圖片失敗。具體操作方法：打開控制台--設定默認程式--選擇照片檢視器',
  common_detail_content04:
    '因為我們雲管家播放視頻是基於windows自帶的Windows Media Player，那麼播放視頻出問題首先要驗證windows media player是否可以正常工作。首先確保Windows啟用Windows Media Player功能，並陞級至Windows Media Player 11或以上版本',
  common_detail_content05:
    '原因：可能是因為打開的是雲管家主程序SCP.Desktop.Shell.exe（如下圖）。解決方法：右擊紅框exe--創建案頭快捷方式--添加命令列參數',
  common_detail_content06:
    '出現此現象一般是：遠程相關檔（NNScreen.dll、SCPDesktopRDH.dll）被殺毒軟體（360）誤殺隔離導致',
  author: '作者',
  time: '時間',
  detail_list0101: '解决方案：',
  detail_list0102: '1、添加相容模式並以管理員身份運行！',
  detail_list0103:
    '2、上述方法無果後，查看用戶端.net framework版本是否為4.6或者4.7。',
  detail_list0104: '那麼請卸載高版本的.net，然後安裝4.0版本。',
  detail_list0105: 'dotNetFx40_Full_x86_x64.zip',
  detail_list0106:
    '若安裝如下報錯，請自行百度下載4.5版本安裝後即可解决此問題。',

  detail_list0201:
    '答：退出雲管家--删除我的文件DigiwinSCPConfig資料夾下的SCP.desktop.shell.xml檔案（如下圖）--重新開啟雲管家--會出現客服代號綁定介面，重新綁定',
  detail_list0301:
    '雲管家IM系統查看圖片默認驅動使用的是windows自帶的照片檢視器。',
  detail_list0302:
    '最近wps陞級，會篡改OS默認圖片檢視器為wps看圖，才導致了IM聊天時查看圖片失敗。',
  detail_list0303: '具體操作方法：打開控制台--設定默認程式--選擇照片檢視器。',
  detail_list0401:
    '因為我們雲管家播放視頻是基於windows自帶的Windows Media Player，那麼播放視頻出問題首先要驗證windows media player是否可以正常工作。',
  detail_list0401:
    '首先確保Windows啟用Windows Media Player功能，並陞級至Windows Media Player 11或以上版本。',
  detail_list0402: '解決方案：',
  detail_list0403:
    '然后打开Windows Media Player播放器--文件--打开url--输入上面测试的url--确定（如下图）',
  detail_list0404:
    '那從上述方法測試下來，發現有的客戶其實是網絡問題導致播放視頻需要緩衝…並不是視頻無法播放，等一會就可以了。',
  detail_list0405: '請注意黑屏狀況的客戶播放機左上角是否顯示的正在緩衝…？？',
  detail_list0501:
    '原因：可能是因為打開的是雲管家主程序SCP.Desktop.Shell.exe（如下圖）。',
  detail_list0502:
    '解決方法：右擊紅框exe--創建案頭快捷方式--添加命令列參數：-shortcut（注意空格，如下圖）',
  detail_list0503:
    '注釋：此命令是開啟雲管家時call起雲管家自動更新程式SCP.Desktop.Update.exe',
  detail_list0504:
    '另一種方法：打開update資料夾，右擊update.exe創建快捷方式即可。',
  detail_list0601:
    '出現此現象一般是：遠程相關檔（NNScreen.dll、SCPDesktopRDH.dll）被殺毒軟體（360）誤殺隔離導致',
  detail_list0602: '可以打開360殺毒軟體查看隔離區作如下操作：',
  detail_list0603:
    '選中包含上面兩個DLL檔案的記錄並恢復》》點選將檔案修復到原來所在目錄》》勾選恢復後信任此檔案，不再查殺》》恢復即可',
  detail_list0604:
    '另外這兩個檔案的路徑：雲管家：SCPRuntimeShared易聊：SIMRuntime',

  /* 功能说明文字 */
  introItem01: '安裝說明',
  introItem02: '基本功能',
  introItem03: '連線精靈',
  introItem04: '案件管理',
  introItem05: '知識寶典',
  introItem06: '智能客服',
  introItem07: '資訊中心',
  introItem08: '系統運維',
  introItem09: '我的管家',
  introItem01_01: '鼎新服務雲',
  introItem01_02: '貼近所享，擴展服務邊界',
  introItem01_03:
    '我們用心為用戶帶來數位應用價值，在服務企業的全生命週期以「客戶效益」為核心，為企業提供全程價值服務，並持續關注用戶使用體驗。',
  introItem01_04:
    '2018年推出服務雲管家，承載著為客戶提供升級的服務體驗的理念，服務雲將翻轉傳統服務模式中的被動式，轉為主動感知、即時反應用戶端系統使用及系統運維上的狀況，將眾多服務工具化繁為簡，突破時間、地域、人員的限制，服務上雲的便捷應用讓鼎新服務走在您需要之前。',
  introItem01_05: '超越所想，所及無限',
  introItem01_06:
    '在實現客戶應用價值的管理精進階段中，裝載服務雲管家，透過雲端互聯、AI智能引擊、大數據等新技術，以互聯網思維模式整合多元應用，迭加智能工具與服務，創造出隨選暢想的服務入口，協助營運指標佈建監測、對應職能應用、培訓課程、產品知識庫…等，助力企業持續優化營運與轉型創新。',

  introItem02_01: '安裝鼎新服務雲管家',
  introItem02_02:
  '在產品下載中，選擇服務中心，在點選【立即下載】按鈕進行下載安裝檔(SCP.Desktop.Setup.exe)，下載完成後請執行SCP.Desktop.Setup.exe進行安裝。',
  introItem02_03: '開啟鼎新客服連線精靈時，若出現下圖訊息，按下',
  introItem02_04: '按鈕，即會自動下載鼎新服務雲管家安裝程式進行安裝',
  introItem02_05: '安裝完後，於桌面會新增',
  introItem02_06: '的捷徑。',
  introItem02_07: '登入/登出/關閉鼎新服務雲管家',
  introItem02_08: '如何登入雲管家',
  introItem02_09:
    '執行鼎新服務雲管家後的畫面如下圖，必須登入系統才能使用雲管家功能，請點選',
  introItem02_10: '【請登入】',
  introItem02_11: '進行用戶的註冊登入',
  introItem02_12: '按下',
  introItem02_13: '後出現【帳號登入】',
  introItem02_14: '(此功能暫未開放)',
  introItem02_15: '已有鼎新用戶服務平台的帳號',
  introItem02_15_1: '請輸入鼎新用戶服務平台的登入E-Mail及密碼，之後按下',
  introItem02_16: '【登入】',
  introItem02_17:
    '首次以鼎新用戶服務平台帳號登入時，須完善帳號資訊。完善帳號資訊之後，按下',
  introItem02_18: '【確定】',
  introItem02_19:
    '按鈕即完成服務雲帳號綁定。往後即可直接以鼎新用戶服務平台帳號登入。',
  introItem02_20: '沒有鼎新用戶服務平台帳號',
  introItem02_21: '請點選',
  introItem02_22: '【註冊】',
  introItem02_23: '按鈕，註冊鼎新服務雲管家帳號',
  introItem02_24: '按下註冊後，您將看到以下畫面，請輸入貴公司的',
  introItem02_25_1: '客服代號',
  introItem02_25_2: '與',
  introItem02_25_3: '客服密碼',
  introItem02_26: '，且依畫面提示輸入您的個人資訊，並按下',
  introItem02_27: '， 您的帳號即建立完成。',
  introItem02_28: '註:預設產品為定義登入雲管家後所預設的產品線。',
  introItem02_29: '如何登出雲管家',
  introItem02_30:
    '於雲管家畫面的右上方點選【≡】後再點選【帳號登出】即可登出當前所登入的帳號。',
  introItem02_31:
    '也可在雲管家主畫面的〝歡迎您使用鼎新雲管家〞的地方按滑鼠右鍵，即可出現',
  introItem02_32: '【登出】',
  introItem02_33: '字樣，點選後即可登出當前所登入的帳號。',
  introItem02_34: '如何關閉雲管家',
  introItem02_35:
    '在作業系統工作列右下方的鼎新服務雲管家圖示，按滑鼠右鍵，選擇',
  introItem02_36: '即可關閉鼎新服務雲管家',
  introItem02_add_36: '右上角菜單欄退出程序',
  introItem02_37: '於設定中心->主頁，設定雲管家關閉的模式',
  introItem02_37_1: '主頁',
  introItem02_38: '隱藏到任務欄通知區域，不退出程式：',
  introItem02_39: '於雲管家主畫面按X關閉時，隱藏到任務欄通知區域',
  introItem02_40: '退出程式：',
  introItem02_41: '於雲管家主畫面按X關閉時，直接關閉雲管家',

  introItem03_01:
    '依客戶所購買的產品來顯示，可用於不同產品問題的反應，例如，要發送WorkFlow ERP線上問題登錄，就選WorkFlow ERP，要發送Smart ERP線上問題登錄，就選Smart ERP。',
  introItem03_02: '切換產品線',
  introItem03_03: '可設定各項系統基本設定值',
  introItem03_04: '可設定是否於開機自動啟動雲管家',
  introItem03_04_1: '註:預設為開機自動啟動雲管家。',
  introItem03_05: '【主頁】',
  introItem03_06: '設定雲管家關閉的模式',
  introItem03_07: '【文件下載】',
  introItem03_08: '設定下載文件時預設的目錄',
  introItem03_09: '【ERP管理】',
  introItem03_10: '設定ERP安裝目錄',
  introItem03_11: '【多產品管理】',
  introItem03_12:
    '如貴公司有購買多項鼎新產品，可於此設定每次登入雲管家預設的產品線，提供該產品線相關的服務',
  introItem03_13: '【多語言管理】',
  introItem03_14: '設定雲管家介面所要呈現的語言，可選擇繁體及簡體',
  introItem03_15: '【網路代理設置】',
  introItem03_16:
    '如果貴公司上網是透過Proxy網路代理上網時, 可在網路代理設置進行設定，可設定直接使用瀏覽器的設置，或是以手動方式自行設置',
  introItem03_17: '設定中心',
  introItem03_17_01: '個人中心',
  introItem03_18:
    '可查看個人註冊時的相關資料、系統通知公告，以及相關活動所獲得之獎券。',
  introItem03_19: '【我的資料】',
  introItem03_20: '註冊時的基本資料，亦可點選',
  introItem03_20_1: '【編輯】做基本資料的修改。',
  introItem03_21: '【通知公告】',
  introItem03_22: '可查看系統發送的公告',
  introItem03_23: '【我的獎券】',
  introItem03_24:
    '個人於鼎新服務雲管家相關活動所獲得之獎券。可於此做獎券的兌換。',
  introItem03_25: '【他人獎券】',
  introItem03_26: '可查看貴公司其他同仁所獲得之獎券。',

  introItem04_01: '如何使用連線精靈',
  introItem04_02:
    '用於提供使用者電腦，讓鼎新數智客服人員進行連線查看系統問題時使用。',
  introItem04_03: '[取得被控端ID] 按鈕說明',
  introItem04_04:
    '按下按鈕後,顯示免責說明:',
  introItem04_05: '您按下 [接受] 後, 會產生9碼的數字,如下圖,再請您把9碼的數字通知鼎新數智人員',
  introItem04_06: '提醒: 當鼎新數智人員使用主控端連入時,您必須按下 [允許] 按鈕才能連線,如下圖',
  introItem04_07: '[取得被控端ID(無人值守)] 按鈕說明:',
  introItem04_08: '此功能使用情境為：',
  introItem04_09: '當您可能不在座位上等待主控端連入時且您也同意鼎新/鼎捷人員可以連入,可以使用無人值守的功能。',
  introItem04_10: '無人值守的功能為：當主控端連入時, 如果您未在30秒內按下[允許]或[拒絕]時, 最後主控端可以自動連入被控端的電腦。',
  introItem04_11: '使用無人值守的模式時, 系統會跳出免責聲明, 您要按下[同意免責聲明], 才能使用',
  introItem04_12: '您按下 [接受] 後, 會產生9碼的數字,如下圖,再請您把9碼的數字通知鼎新數智人員',

  introItem05_01: '案件管理介紹',
  introItem05_02:
    '案件管理主要就是針對客戶已經提交到客服中心的案件管理，主要是追蹤案件的處理進度（處理中，還是已結案），查看案件的處理結果，以及歷史案件的處理描述。',
  introItem05_03: '案件管理介面可以看出所選擇的',
  introItem05_04: '【產品線】',
  introItem05_05:
    '正在處理中的案件數量以及已經解決的案件數量。點選處理中的案件數可以直接連結到案件一覽裡面的處理中的案件。',
  introItem05_06: '提交問題',
  introItem05_0602: '在雲管家中的部份產品線為提供給使用者更便利的操作介面，把【提交問題】跟【智能客服】功能結合在一起，都整合【智能客服】功能中，單一入口讓您點選更直覺、操作更便利。',
  introItem05_07: '選擇所要提交問題的產品線',
  introItem05_08: '點選提交問題按鈕',
  introItem05_09:
    '點選【提交問題】按鈕後即可跳到案件提交的介面，供您反應您的問題。',
  introItem05_10: '輸入所要反應的使用問題，並提交問題',
  introItem05_11: '增加附件',
  introItem05_12: '點選',
  introItem05_13: '【選擇檔案】',
  introItem05_14: '可以選擇要上傳的附件。點選',
  introItem05_14_1: '【截圖】',
  introItem05_14_2: '可開啟截圖功能，截圖後會自動成為附件。',
  introItem05_15: '聯繫方式：',
  introItem05_16:
    '提供本次反應問題者的聯繫方式，只能選擇一位。可利用增加、編輯、刪除等功能來進行維護。',
  introItem05_17: '副本寄送：',
  introItem05_18:
    '將本次反應的問題內容，同時寄送給副本收件人員。於提交問題後，該副本寄送名單，會儲存在歷史記錄，以供下回快速點選加入。',
  introItem05_19:
    '案件提交後，系統會發送問題提交成功的MAIL給聯繫人及副本寄送人',
  introItem05_19_1:
    '註：案件提交的功能也可以從【我的管家】頁面的『案件提交』來使用',
  introItem05_19_2:  '在雲管家中的部份產品線為提供給使用者更便利的操作介面，把【提交問題】跟【智能客服】功能結合在一起，都整合【智能客服】功能中，單一入口讓您點選更直覺、操作更便利。',
  introItem05_20: '案件一覽',
  introItem05_21: '點',
  introItem05_22:
    '按鈕後，就可以看到您所有案件的詳情。其中包含處理中及近三個月已結案的案件。',
  introItem05_23:
    '註：新註冊的雲管家用戶，如果以前曾有反應案件到客服中心，要到隔天才會看到這些案件',
  introItem05_24: '點擊進階搜索可以選擇細化的搜索條目',
  introItem05_25: '點選某一筆案件，再點下一個',
  introItem05_26: '【操作】',
  introItem05_27: '欄位的按鈕，可查看目前案件的詳情及進度',
  introItem05_28:
    '可依需求做一般的問題描述查詢或進階查詢，亦可將目前列表中所查看到的案件詳情資訊匯出。',

  introItem05_01: '案件管理介紹',
  introItem05_02:
    '案件管理主要就是針對客戶已經提交到客服中心的案件管理，主要是追蹤案件的處理進度（處理中，還是已結案），查看案件的處理結果，以及歷史案件的處理描述。',
  introItem05_03: '案件管理介面可以看出所選擇的',
  introItem05_04: '【產品線】',
  introItem05_05:
    '正在處理中的案件數量以及已經解決的案件數量。點選處理中的案件數可以直接連結到案件一覽裡面的處理中的案件。',
  introItem05_06: '提交問題',
  introItem05_07: '選擇所要提交問題的產品線',
  introItem05_08: '點選提交問題按鈕',
  introItem05_09:
    '點選提交問題按鈕後即可跳到案件提交的界面，反應您的系統使用問題。',
  introItem05_10: '輸入所要反應的使用問題，並提交問題',
  introItem05_11: '增加附件',
  introItem05_12: '點選',
  introItem05_13: '【選擇檔案】',
  introItem05_14: '可以選擇要上傳的附件。點選',
  introItem05_14_1: '【截圖】',
  introItem05_14_2: '可開啟截圖功能，截圖後會自動成為附件。',
  introItem05_15: '聯繫方式：',
  introItem05_16:
    '提供本次反應問題者的聯繫方式，只能選擇一位。可利用增加、編輯、刪除等功能來進行維護。',
  introItem05_17: '副本寄送：',
  introItem05_18:
    '將本次反應的問題內容，同時寄送給副本收件人員。於提交問題後，該副本寄送名單，會儲存在歷史記錄，以供下回快速點選加入。',
  introItem05_19:
    '案件提交後，系統會發送問題提交成功的MAIL給聯繫人及副本寄送人',
  introItem05_20: '案件一覽',
  introItem05_21: '點',
  introItem05_22:
    '按鈕後，就可以看到您所有案件的詳情。其中包含處理中及近三個月已結案的案件。',
  introItem05_23:
    '註：新註冊的雲管家用戶，如果以前曾有反應案件到客服中心，要到隔天才會看到這些案件',
  introItem05_24: '點擊進階搜索可以選擇細化的搜索條目',
  introItem05_25: '點選某一筆案件，再點下一個',
  introItem05_26: '【操作】',
  introItem05_27: '欄位的按鈕，可查看目前案件的詳情及進度',
  introItem05_28: '點擊右上角綠色按鈕，可以導出案件列表',

  introItem06_01: '知識寶典介绍',
  introItem06_02:
    '知識寶典是一種類似Google的搜尋引擎，可以透過關鍵字的形式搜索知識庫，通過檢索關鍵字可以找到相關問題的解決方案。解決方案包含文字形式、圖文形式，以及影音形式。知識寶典裡面的內容我們會定期更新完善，內容會越來越豐富。並且提供收藏功能，對您感興趣的內容點選收藏後，方便又快捷找到您感興趣的內容。還提供知識分享的功能，把您認為有用的知識分享給其他人。',
  introItem06_03: '【模糊搜尋】',
  introItem06_04: '找出與輸入的關鍵字完全或部分符合的內容',
  introItem06_05: '【關鍵字搜尋】',
  introItem06_06: '找出與輸入的關鍵字完全符合的內容',
  introItem06_0502: '【影音推薦】',
  introItem06_0602: '顯示該產品線目前推薦的影音清單',
  introItem06_07: '【最新上架】',
  introItem06_08: '一個月內該產品線發佈的知識庫數量統計',
  introItem06_09: '【累計上架】',
  introItem06_10: '該產品線所有發佈的知識庫數量統計',
  introItem06_11: '【累計搜尋】',
  introItem06_12: '所有搜尋次數的數量統計',
  introItem06_13: '【累計查看】',
  introItem06_14: '搜尋到資料後，所有查看內容次數的數量統計',
  introItem06_15: '【最新影音知識點】',
  introItem06_16: '顯示該產品線目前最新上架的影音清單',
  introItem06_17: '如何搜尋知識庫',
  introItem06_18: '選擇所要搜尋的產品別',
  introItem06_19: '輸入搜尋的條件',
  introItem06_20: '例如：想要搜尋有關於成本的影音知識庫，先點選',
  introItem06_21:
    '，然後在搜尋欄內輸入成本，再按下搜尋按鈕，即可搜尋有關成本的影音知識庫內容。',
  introItem06_22: '註：搜尋知識庫的功能也可以從',
  introItem06_23: '頁面的',
  introItem06_23_1: '『知識搜尋』',
  introItem06_23_2: '來使用',
  introItem06_24: '如何收藏知識庫',
  introItem06_25: '在所要收藏的知識庫內容右上方，點選',
  introItem06_26: '，即可將此則知識庫內容進行收藏。',
  introItem06_27: '如何查看已收藏的知識庫',
  introItem06_28: '，即可查看已收藏的知識庫內容',
  introItem06_29: '如何分享知識庫',
  introItem06_30: '可以將您認為有用的內容分享給其他同事，點選【分享】，接著點選【複製連結】',
  introItem06_31:
    '將系統複製在剪貼簿裡的連結，以MAIL或是通訊軟體將該連結提供給您的同事。',
  introItem06_32:
    '將複製在剪貼簿的連結傳送給您要分享的對象，當對方複製並登入鼎新服務雲管家之後，就會出現如下所示對話視窗，點選',
  introItem06_33: '【查看詳情】',
  introItem06_34: '按鈕即可。',

  introItem07_01: '智能客服介紹',
  introItem07_02:
    '可利用此項服務，透過文字方式，即時與機器人詢問系統操作問題，或與線上文字客服人員進行交談解決系統使用問題。',
  introItem07_03: '如何使用智能客服',
  introItem07_04: '選擇產品別',
  introItem07_05: '(產用產品線：Workflow ERP、Smart ERP、CosmosERP/POS)',
  introItem07_06: '按鈕',
  introItem07_07: '進入後可與AI智能客服對談詢問系統問題，也可以點選視窗中的知識寶庫，學習相關系統知識。',
  introItem07_0702: '當AI智能客服不了解您詢問的問題時，會出現您可以進行案件提交或是可以連線真人文字客服(上班期間)的選項。',
  introItem07_08: '點選右上方',
  introItem07_09: '【連線真人文字客服】',
  introItem07_10: '按鈕，可與真人文字客服對談',

  introItem08_01: '資訊中心介紹',
  introItem08_02:
    '【資訊中心】提供串連到鼎新數智用戶服務各項功能及工具下載。',
  introItem08_03: '【合約資訊】',
  introItem08_04: '顯示合約購買模組或各項服務使用說明及使用狀況。',
  introItem08_05: '【修正程式下載】',
  introItem08_06:
    '此功能為授權給鼎新合約客戶使用，供下載取得最新修正程式。( 註：部份產品未提供此功能)',
  introItem08_07: '【系統文件下載】',
  introItem08_08:
    '系統文件區，提供客戶經常性來電索取之文件，您可以透過此處直接下載。',
  introItem08_09: '【知識學院】',
  introItem08_10:
    '您可以透過此功能查看鼎新台灣各區分公司全年度對外公開活動及課程行事曆，點選單一課程可以查看詳細活動內容及課程明細。',
  introItem08_11: '【訂閱電子報】',
  introItem08_12: '提供鼎新最新消息發佈、各職能資訊及系統應用資訊。',
  introItem08_13: '【委託個案】',
  introItem08_14: '隨時提供鼎新為您客製化修改的程式內容及完成進度查詢。',
  introItem08_15: '【產品功能文件下載】',
  introItem08_16:
    '此功能授權給鼎新合約客戶下載使用，想知道最新產品功能及作業程序，建議您可以下載參考文件。',
  introItem08_1502: '【出貨文件下載】',
  introItem08_1602:
    '出貨文件區，提供出貨文件可供客戶下載。',    
  introItem08_17: '【企業學習網】',
  introItem08_18: '串連到鼎新企業學習網站。',
  introItem08_19: '【用戶學習網】',
  introItem08_20: '串連到鼎新用戶學習網站。',
  introItem08_21: '註：詳細鼎新用戶服務平台使用說明點此參考。',
  introItem08_22: '點此參考。',
  introItem09_001: '系統運維介紹',
  introItem09_01: '整合鼎新數智Ai智管家智能管理平台,顯示異常伺服器數量及預警數量,您可以點選[Ai智管家]按鈕開啟Ai智管家智能管理平台,Ai智管家透過AI技術協助企業簡化資訊日常維運，整合管理資訊設備，24小時監控，異常即時告警，幫助管理人員快速應對，降低成本並避免營運中斷。',
  introItem10_01:
    '我的管家是登入鼎新服務雲管家後的首頁，其中包含了客服專員、知識搜尋、案件提交、文字客服、智慧客服等功能。',
  introItem10_01_01:
    '其中【未讀公告】，可查看服務雲管家所發送的公告通知。【處理中案件】可查看反應客服處理中的案件。而畫面左上角的跑馬燈則是顯示最新的公告。',
  introItem10_02: '知識搜尋',
  introItem10_02_01:
    '可以透過關鍵字的形式搜尋知識庫，通過檢索關鍵字可以找到相關問題的解決方案。解決方案包含文字形式、圖文形式，以及影音形式。詳細使用可參考',
  introItem10_02_02: '知識寶典',
  introItem10_02_03: '裡的說明。',
  introItem10_03: '選擇所要搜尋的產品線',
  introItem10_04: '點選知識搜尋按鈕',
  introItem10_05: '輸入搜尋的條件',
  introItem10_06:
    '例如：想要搜尋有關於成本的知識庫，搜尋欄內輸入成本，再按下搜索按鈕，即可搜尋有關成本的知識庫內容。',
  introItem10_07: '案件提交',
  introItem10_08:
    '可以提交問題到客服中心，由客服人員為您回覆說明。詳細使用可參考',
  introItem10_08_1: '案件管理',
  introItem10_08_2: '點選【案件提交】後即可跳到案件提交的介面。',

  languageCN:'简体中文',
  languageTW:'繁體中文',
  languageEN:'English',
  languageTHAI:'ไทย',
  languageVN:'Tiếng việt nam',
  service: '服務',
  cloud: '雲',
  manager: '管家',
  p_detail_01: '我們用心為用戶帶來數位應用價值，在服務企業的全生命週期，以「',
  p_detail_02: '客戶效益',
  p_detail_03: '」為覈心，為企業提供全程價值服務，並持續關注用戶使用體驗。',
  p_detail_04: '默認服務中心',
  p_detail_05: '大陸',

  dl: '大陸',
  tw: '臺灣',
  yn: '越南',
  mlxy: '馬來西亞',
  tg: '泰國',
  english: 'English',

  serviceCloud: '服務雲管家',
  ITCloud: 'Ai智管家',
  ITCloud_TW: 'Ai智管家',
  ITCloud_CN: '鼎捷智管家',
  message01: '免費為鼎新鼎捷客戶提供2台主機預警服務',
  message02: '提供全面的巡檢服務',
  message03: '協助您進行IT運維，提高效率',
  message04: 'IT資產管理',
  message05: '助您了解公司內主機的硬體、軟體資訊， 讓您的管理更輕鬆',
  message06: '運維報告',
  message07:
    '鼎新專業的運維工程師，為您提供本公司的運維分析建議，讓您的運維更加穩健',
  scpinstallmsg: '請先安裝鼎新雲管家或升級至最新版本！',
  
  policyTitle:'鼎新隱私政策',
  policyContent:'鼎捷(鼎新數智股份有限公司、鼎捷軟件股份有限公司及其關聯公司)尊重並保護您的隱私權。本「鼎新隱私政策」的目的在告知您我們對於個人資料的蒐集、處理、利用，皆符合個人資料保護法及其他相關隱私權規範要求說明。鼎捷致力於隱私權保護的做法遵循相關個人資料保護之規範，包括蒐集、處理、利用、國際傳輸以及當事人權利行使等法律要求之作為。 若您對於這份聲明有任何問題或疑慮，請於本公司上班時間以電話或電子郵件聯繫，電話：0800-009-890，mail：dscmaz@digiwin.com。',
  policyItem01:'1.適用本「鼎新隱私政策」的網站',
  policyItem01_1:'本「鼎新隱私政策」適用於所有隸屬於鼎捷及其完全擁有之子公司的網站與網域 (「鼎捷網站」)。',
  policyItem01_2:'非鼎捷網站的連結',
  policyItem01_3:'鼎捷網站為了您的方便與資訊取得，可能提供連結至第三方網站。如果您進入那些連結，您將會離開鼎捷網站。鼎捷無法控制那些網站及其對於隱私權保護的做法，它們可能和鼎捷的做法不同。我們不為第三方網站背書，也不代表任何第三方網站。您選擇提供給第三方網站的個人資料或第三方網站所收集到的您的個人資料都不在鼎捷「個資暨隱私權聲明」的涵蓋範圍之內。建議您在提供個人資料給任何公司之前，先查看該公司的隱私權政策。',
  policyItem02:'2.個人資料的蒐集',
  policyItem02_1:'為提供您更好的產品與服務，鼎捷在充分告知與取得您的同意之下，將於必要時蒐集、處理與利用您的個人資料。例如，當您訂購產品或服務、索取資訊、訂閱行銷或支援資料、註冊您個人或您的鼎捷產品、參加競賽或參與調查、或申請鼎捷的工作，我們都會請您提供個人資料以完成這些業務。我們所蒐集的個人資料將包含個人姓名、公司名稱、職稱、地址、電話及電子郵件地址等得以直接或間接識別個人的相關資訊。',
  policyItem02_2:'除了您所提供的資料，鼎捷也可能在您造訪鼎捷網站時透過我們的「資訊暫時儲存」收集資料，這些工具包括Cookie、嵌入式網路連結、及其他普遍使用的資訊收集工具。這些工具收集由您的瀏覽器傳送到我們網站的某些標準資訊，如您的瀏覽器類型和語言、存取時間、以及您由何網站連結至鼎捷網站。 它們也可能收集有關您IP位址、點選流向行為 (即您瀏覽的網頁、您點選的連結和與鼎捷網站有關的其他行為) 和產品的資訊。 IP位址是一組自動指定給您電腦的號碼，每當您在網路瀏覽時，網路伺服器可藉此辨識您的電腦。 電腦藉由IP位址在網際網路溝通，讓使用者可以瀏覽與購物。 鼎捷也可能把自動資訊收集工具與鼎捷寄出的某些電子郵件連結，以便在您打開電子郵件或點選電子郵件中的連結時收集資訊。',
  policyItem03:'3.我們如何使用您的資料',
  policyItem03_1:'鼎捷所蒐集之個人資料，將僅限使用於本公司合於營業登記項目或章程所載及業務需要之客戶管理、行銷及營業範圍內相關服務使用，期限自取得起始日至特定目的終止日為止，並遵守「個人資料保護法」之規定妥善保護您的個人資訊。於此前提下，您同意本公司得於法律許可之範圍內處理及利用相關資料以提供資訊或服務，並得於本公司之營運地區向您提供優惠資訊。',
  policyItem04:'4.個人資料委託關係之管理責任',
  policyItem04_1:'鼎捷與供應商將提供完整的產品、服務與客戶解決方案，並協助鼎捷進行行銷與交流活動。舉例來說，我們的委託機關包含客戶支援、電子郵件服務公司、自動化資訊處理業者、貨運代理公司及行銷活動協辦單位等。',
  policyItem04_2:'為落實個資法施行細則第八條於委託他人蒐集、處理或利用個人資料時，委託機關應對受託者為適當之監督。要求之遵循，與本法第四條委託他人蒐集、處理及利用個人資料者視同委託機關，本公司將定期確認受託機關執行之狀況，並將確認結果記錄。',
  policyItem05:'5.關於您得主張的權利',
  policyItem05_1:'鼎捷竭力維護您個人資訊的安全性與正確性。 我們採行了一些技術、管理程序和政策來維護客戶資料的正確性。 鼎捷提供個人合理的存取權以存取他們提供給鼎捷的個人資料。',
  policyItem05_2:'依據個人資料保護法提供您可主張之權利如下：',
  policyItem05_3:'一、查詢或請求閱覽。',
  policyItem05_4:'二、請求製給複製本。',
  policyItem05_5:'三、請求補充或更正。',
  policyItem05_6:'四、請求停止蒐集、處理或利用。',
  policyItem05_7:'五、請求刪除。',
  policyItem05_8:'若您欲行使前述權利，請於本公司上班時間以電話或電子郵件聯繫，電話：0800-009-890；Mail：dscmaz@digiwin.com。',
  policyItem05_9:'關於電子郵件之退訂管道，請您採用下列方式進行：',
  policyItem05_10:'請選取電子郵件中「退出」或「取消訂閱」連結，或者遵照每一項通訊中的退出指令。',
  policyItem05_11:'請E-mail至dscmaz@digiwin.com，務必提供您的姓名、電子郵件和郵寄地址，以及您要停止的訂閱相關資訊。',
  policyItem05_12:'請注意：當您行使刪除或退訂相關作業後，您可能就無法繼續享有本公司提供之相關活動與獲取各項資訊之權利。關於電子郵件之退訂管道，請您採用下列方式進行：',
  policyItem06:'6.維護您資料的安全',
  policyItem06_1:'鼎捷認真看待您對我們的信任。 為了防範未經授權的存取或洩露、維護資料的正確性，以及確保資訊的適當運用，鼎捷採取了一些適當的實質上的、技術上的以及管理上的程序來保護所蒐集的個人資料，以避免遭受未經授權的存取、使用或外洩。',
  policyItem07:'7.鼎捷集團如何使用資訊暫時儲存：',
  policyItem07_1:'Cookie',
  policyItem07_2:'Cookie 是一種由網站傳輸到您電腦硬碟上的小型資料檔。 當您瀏覽我們的網站、進行購買、要求資訊或將資訊個人化，或者註冊某些服務時，鼎捷就會傳送 Cookie。接受網站上所使用的 Cookie 並不能讓我們存取您的個人資訊，但是我們會使用這些 Cookie 識別您的電腦。 Cookie 通常區分為「工作階段」Cookie 或「永久性」Cookie。',
  policyItem07_3:'「工作階段」 Cookie 在您關掉瀏覽器之後，不會停留在您的電腦上。',
  policyItem07_4:'「永久性」 Cookie會一直停留在您的電腦，直到您將它們刪除或它們過期。 大部份的瀏覽器是預設自動接受 Cookie，但是您通常還是可以藉由調整瀏覽器的偏好選項來拒絕 Cookie 或是選擇性地接受 Cookie。 如果關掉 Cookie，您可能無法使用我們網站的某些功能，而且有些網頁可能也將無法正常顯示。',
  policyItem07_5:'內嵌式網路連結',
  policyItem07_6:'舉凡鼎捷寄發的電子郵件、經鼎捷預先組態之網際網路鍵盤鍵、或是預先安裝在您桌上型個人電腦內的行銷圖示，通常都運用連結，在經由鼎捷伺服器的重新導向之後，帶領您到網路上的相關區域。 重新導向系統在必要時可以讓鼎捷改變這些連結的目的地 URL，也可以讓我們知道行銷活動的有效性。',
  policyItem07_7:'在電子郵件中，這樣的網路連結也可以讓鼎捷知道您是否曾經點選電子郵件中的連結，而我們可能將這樣的互動訊息與您的個人身份連結。 如果您不要鼎捷收集有關您點選連結的資訊，您可以：',
  policyItem07_8:'改變您由鼎捷接收通訊的方式 (例如，如果有選擇文本版本的訊息) 或選擇不要點選鼎捷寄發之電子郵件內的連結。',
  policyItem07_9:'刪除鼎捷預先安裝在您桌上型個人電腦中的行銷圖示，或選擇不要點選那些圖示。',
  policyItem07_10:'運用您個人電腦所附之說明，重新組態在某些型號個人電腦上的網際網路鍵盤鍵，設定一個您自己選擇的目的地URL。',
  policyItem07_11:'刊登於第三方網站的鼎捷廣告',
  policyItem07_12:'與服務供應商簽約，以刊登廣告於第三方擁有之網站。 服務供應商由第三方網站送出Cookie，並在這些網站上使用網路信標 (Web beacon)。 這些 Cookie 和網路信標 (Web beacon) 可讓鼎捷收集到有關您瀏覽網頁與點選連結的資訊。',
  policyItem07_13:'資訊收集工具',
  policyItem07_14:'鼎捷可能使用工具收集您在某些鼎捷網站瀏覽過程之相關資訊。 這些工具和網路信標 (Web beacon) 或 Cookie 的使用無關，而是由鼎捷伺服器記錄下您與鼎捷網站的互動。 在某些國家所使用的一些工具，可讓鼎捷重播客戶的網路對話。這些工具的主要用途在於故障檢修；而這些工具所收集的資訊將被儲存一小段時間。',
  policyItem08:'8.隠私政策之變更',
  policyItem08_1:'為了保護用戶隱私並遵守社會和法律環境的變化，我們有權修改隱私政策。任何變更將及時在鼎捷網站上更新和公告，請定期閱讀以保護您的權益。',
  policyItem09:'9.與我們聯絡',
  policyItem09_1:'我們非常重視您的意見。 如果您對於我們的隱私政策有任何指教或疑問，請E-mail至dscmaz@digiwin.com或寫信至新北市新店區中興路一段222號 鼎捷(鼎新數智) 市場資訊部收。',

  policyUserTitle:'鼎新雲管家用戶使用協議',
  policyUserContent:'歡迎閱讀以下《鼎新雲管家用戶使用協議》（以下簡稱“本協議”）。 本協議內容包括協議本文及所有透過“鼎新雲管家”已經發佈的或未來可能發佈的各項服務對應的服務協議、使用規則、結算規則、法律聲明等， 均視為本協議的一部分，與本協議具有相同法律效力。',
  policyUserContent1:'本協議是您與鼎新數智股份有限公司及其關聯方（以下簡稱“鼎新數智”或“我們”）之間關於您使用“鼎新雲管家”所訂立的條款。為使用“鼎新雲管家”，服務使用人（以下簡稱“用戶”或“您”）應當閱讀並遵守本協議，請您務必審慎閱讀、充分理解各條款內容，特別是免除或者限制責任的條款。 您確認，您是具備民法權利能力和民法完全行為能力的自然人、法人或其他組織（以下簡稱“法律主體”）， 如您代表法人或其他法律主體進行註冊或以其他允許的方式實際使用本服務，視為您已經獲得該法人或該法律主體授權同意受本協議條款的約束。',
  policyUserContent2:'如果您不具備前述法律主體資格，請立即停止註冊程序及在鼎新雲管家上的任何操作，且“鼎新雲管家”有權註銷您的帳號。',
  policyUserContent3:'如“鼎新雲管家”因此受到損失，將向您和/或您的法定代理人請求損害賠償。',
  policyUserContent4:'您同意並接受《鼎新雲管家用戶使用協議》後才能正式進入“鼎新雲管家”線上申請程序，',
  policyUserContent5:'當您按照頁面提示同意本協議，表示您同意接受本協議。否則，請您退出。',
  policyUserItem01:'1 服務聲明',
  policyUserItem01_1:'1.1 鼎新雲管家的具體內容由鼎新數智根據實際情況提供，鼎新數智及鼎新雲管家有權對其提供的服務或產品形態進行升級或其他調整，並將及時告知您。',
  policyUserItem01_2:'1.2 鼎新雲管家僅提供與服務相關的技術支援，除此之外與相關網路服務有關的設備（如個人電腦、手機、及其他與接入網際網路或行動網路有關的裝置） 及所需的費用（如為接入網際網路而支付的電話費及上網費、為使用行動網路而支付的手機費）均應由您自行負擔。',
  policyUserItem02:'2 鼎新雲管家的使用',
  policyUserItem02_1:'2.1 鼎新雲管家針些特定服務的使用透過任何方式（包括但不限於網對某頁公告、系統通知、電子郵件、簡訊提醒等）作出的任何聲明、通知、 警示等內容均視為本協議的一部分，您如使用該特定服務，視為您同意該等聲明、通知、警示的內容。',
  policyUserItem02_2:'2.2 您承諾自己在使用鼎新雲管家的所有行為均遵守國家法律、法規和本網站的相關規定以及各種社會公共利益或公共道德。對於任何法律後果的發生， 您將以自己的名義獨立承擔所有相應的法律責任，鼎新雲管家不承擔任何責任。',
  policyUserItem02_3:'2.3 您在使用服務時如發現服務系統或其他相關系統的資訊安全漏洞需及時通知鼎新雲管家，禁止對鼎新雲管家系統進行漏洞掃描、 滲透測試等可能造成鼎新雲管家損失的行為。',
  policyUserItem02_4:'2.4 除非法律允許或鼎新數智書面許可，你使用本產品或服務過程中不得從事下列行為：',
  policyUserItem02_41:'2.4.1 刪除本產品及其副本上關於著作權的資訊；',
  policyUserItem02_42:'2.4.2 對鼎新數智擁有的智慧財產權內容進行使用、出租、出借、複製、修改、鏈接、轉載、彙編、發表、出版、建立鏡像網站等；',
  policyUserItem02_43:'2.4.3 對本產品或者本產品運行過程中釋放到任何終端記憶體中的數據、產品運行過程中客戶端與伺服器端的交互數據，以及本產品運行所必需的系統數據， 進行複製、修改、增加、刪除、掛接運行或創作任何衍生作品，形式包括但不限於使用插件、外掛或非經鼎新數智授權的第三方工具/服務接入本產品和相關系統；',
  policyUserItem02_44:'2.4.4 透過修改或偽造產品運行中的指令、數據，增加、刪減、變動產品的功能或運行效果，或者將用於上述用途的產品、 方法進行運營或向公眾傳播，無論這些行為是否為商業目的；',
  policyUserItem02_45:'2.4.5 自行或者授權他人、第三方產品對本產品及其組件、模組、數據進行干擾；',
  policyUserItem02_46:'2.4.6 其他未經鼎新數智或鼎新雲管家明示授權的行為。',
  policyUserItem02_5:'2.5 您的網路和連接。除雙方另有書面約定外，您應（a）確保用戶方網路和系統符合我們隨時提供的相關規範（如有）； （b）全權負責採購和維護從您的系統到我們或任何第三方數據中心的網路連接和電信連接；並且（c）自行承擔所有因您的網路連接、 電信連接或因網際網路引起的或與之相關的所有問題、條件、延遲、交付失敗和所有其他損失、損壞、責任、費用或任何性質或種類的費用。',
  policyUserItem02_6:'2.6 帳號',
  policyUserItem02_61:'（1） 用戶使用“鼎新雲管家”，需註冊一個帳號。',
  policyUserItem02_62:'該帳號是用戶用來管理“鼎新雲管家”身份的憑據。帳號的所有權歸“鼎新雲管家”所有，用戶完成申請註冊手續後，僅獲得該帳號的使用權，且該使用權僅屬於初始申請註冊人。 同時，初始申請註冊人不得贈與、借用、租用、轉讓或售賣帳號或者以其他方式許可非初始申請註冊人使用帳號。 非初始申請註冊人不得透過受贈、繼承、承租、受讓或者其他任何方式使用帳號。',
  policyUserItem02_63:'（2）為了創建帳號，用戶有義務在註冊時提供用戶名、密碼、以及一些必要的資料資訊，例如：聯繫人姓名、手機、電子郵件及其身份資訊等， 用戶需要保證其真實性、有效性及安全性。如用戶提供的資料資訊有任何變動，用戶應及時更新。',
  policyUserItem02_64:'（3）用戶申請並創建成功帳號後，用戶不得將帳號資訊透露給任何其他人，用戶自行負責自己帳號的保密和安全， 並對用戶的帳號發生的或透過用戶的帳號發生的一切活動負全責。用戶應當使用由字母、數字、特殊字元組成的密碼（最好８位以上長度）， 並應定期更改密碼。當用戶使用完畢後，應安全退出。因用戶保管不善可能導致遭受盜號或密碼失竊，責任由用戶自行承擔。',
  policyUserItem03:'3 安全與隱私',
  policyUserItem03_1:'3.1 安全。',
  policyUserItem03_11:'鼎新雲管家會採取技術措施和其他必要措施保護鼎新雲管家本身的網路安全和穩定運行。',
  policyUserItem03_2:'3.2 鼎新雲管家隱私保護。',
  policyUserItem03_21:'就您使用鼎新雲管家過程中向鼎新雲管家提供的個人資訊，包括但不限於您的姓名、電子郵件、聯繫電話，鼎新雲管家將嚴格遵守相關法律法規及＜鼎新隱私政策＞聲明的要求保護您的資訊。',
  policyUserItem04:'4 數據安全與保密',
  policyUserItem04_1:'4.1 本服務所稱之機密資料，係指由用戶透過雲服務揭露之所有數據。該數據資料包含但不限於：產品規格、制程、 電路圖、線路圖、計畫、設計、產品、特殊訣竅、電腦程式、程式碼、技術圖示以及其他商業上、經濟上或技術上的資料、記錄、資訊等。',
  policyUserItem04_2:'4.2 具有以下的狀況時，則該數據資料即不屬於機密資料：',
  policyUserItem04_21:'(1) 非可歸責於鼎新雲管家之事由而成為眾所周知的資料者；',
  policyUserItem04_22:'(2) 在用戶方將機密資料揭露予鼎新雲管家之前，鼎新雲管家或鼎新數智已知悉該資料。',
  policyUserItem04_3:'4.3 鼎新雲管家同意遵守以下的規定並承擔保密義務：',
  policyUserItem04_31:'4.3.1 鼎新雲管家不得將機密資料揭露予任何第三人。在例外情形之下，鼎新數智雖可將機密資料揭露予其員工、關係企業或承包商， 但僅以有必要者為限，並且鼎新數智必須將該資料具有機密性質之情形對其員工、關係企業或承包商嚴正告誡，並同時須保證其員工、 關係企業或承包商將遵守本使用協議之各項規定。',
  policyUserItem04_32:'4.3.2 鼎新雲管家只能基於特定目的而使用機密資料，並且鼎新雲管家應按照其保護自己具有機密性之資料的注意程度 而對於用戶的機密資料加以保密；但無論如何，鼎新雲管家的注意程度不可低於合理的標準。',
  policyUserItem04_33:'4.3.3 用戶有權隨時要求鼎新歸還該機密資料。',
  policyUserItem04_34:'4.3.4 在以下情形，鼎新雲管家揭露機密資料的行為，並不違反本協議之保密義務：',
  policyUserItem04_341:'(1) 鼎新雲管家依法律規定或法院命令而不得不揭露機密資料。',
  policyUserItem04_342:'(2) 鼎新雲管家取得用戶的事前同意。',
  policyUserItem04_4:'4.4 鼎新雲管家承諾，在有任何用戶資料因伺服器儲存設備損壞時，以最快的速度從最近的備份中恢復資料，但無法承諾100％的資料恢復。鼎新雲管家將全力確保用戶資料安全， 鼎新雲管家對於非由鼎新雲管家故意或重大過失導致的用戶資料遺失或洩露不承擔任何附帶、間接、懲罰性、特殊的責任，除非法律或有權機關另有規定。',
  policyUserItem05:'5 智慧財產權',
  policyUserItem05_1:'5.1 鼎新智慧財產權。',
  policyUserItem05_11:'鼎新數智對鼎新雲管家的商號、商標、功能變數名稱、圖案標示、標誌、標識等歸屬於鼎新數智或識別鼎新數智的所有資訊享有智慧財產權。未經鼎新數智書面許可，在任何情況下，您不得自行或指示第三方使用、複製這些資訊或使用這些資訊進行再造、創造與這些內容有關的派生作品。',
  policyUserItem05_2:'5.2 您的內容。',
  policyUserItem05_21:'您在鼎新雲管家發佈的各類資訊，包括但不限於您對服務的評論，您應確保您的內容不違反本協議的條款和條件並且符合法律法規。您應對您的內容的合法性、準確性、完整性和可靠性負責。除非法律另有明確規定，否則我們不承擔任何與您的內容有關的義務和責任。',
  policyUserItem05_22:'您授予鼎新雲管家託管、處理和/或傳輸您的內容以運行和提供服務的權利，但涉及您的個人資訊的、或您在發佈內容的同時聲明全部或部分保留的，該等使用行為不得違反國家隱私保護法規的規定，或超出您聲明保留的範圍。',
  policyUserItem06:'6 責任限制',
  policyUserItem06_1:'6.1 責任限制。',
  policyUserItem06_11:'無論是否有其他協議約定，我們就我們或我們的任何關聯方在本協議項下的因合約、虛假陳述（不論是侵權的還是法定的）、侵權行為（包括疏忽）和違反法定責任或其他原因所造成的任何性質或種類的損失、損害、罰款、責任、收費、訴訟、費用、支出或成本的最大賠償責任不應超過在該責任產生前十二（12）個月期間您就導致損害賠償的服務實際支付給鼎新雲管家的費用金額。',
  policyUserItem06_2:'6.2 平臺運營風險。',
  policyUserItem06_21:'您理解並同意，儘管鼎新雲管家及鼎新數智採取了必要措施維護鼎新雲管家的正常運營，但依然可能出現下述問題， 您同意因下述問題給您帶來的損失，鼎新雲管家及鼎新數智免責：',
  policyUserItem06_22:'（1）鼎新雲管家及鼎新數智在進行網路調整和維護時進行的服務中斷；',
  policyUserItem06_23:'（2）由於網路上通路的阻塞造成您對服務訪問速度下降；',
  policyUserItem06_24:'（3）因駭客、電腦病毒、木馬或其他惡意程式造成；',
  policyUserItem06_25:'（4）因電信部門技術調整和骨幹網路中斷造成；',
  policyUserItem06_26:'（5）因故障處理的操作維護，包含但不限於故障處理、系統升級、系統調整最佳化等導致；',
  policyUserItem06_27:'（6）因您操作不當或您的電腦軟體、系統、硬體和通信線路的問題引起；',
  policyUserItem06_28:'（7）因您違反鼎新雲管家的使用規則使用相關服務引起；',
  policyUserItem06_29:'（8）其他非鼎新雲管家及鼎新數智過錯導致的問題。',
  policyUserItem06_3:'6.3 僅直接損失：在法律允許的範圍內，在任何情況下，鼎新數智或其關聯公司均不對任何間接、附帶、特殊、後果性、懲戒性損害（包括但不限於損失收入、利潤、機會、客戶、商譽、聲譽、數據或數據使用）負責，即使鼎新數智已被告知該等損害發生的可能性。',
  policyUserItem07:'7 期限、暫停與終止',
  policyUserItem07_1:'7.1 生效。本協議期限自本協議規定生效日期起生效，除非本協議終止，本協議將持續有效。',
  policyUserItem07_2:'7.2 暫停。在下列情況下，我們可能會暫停您訪問或使用鼎新雲管家的權利：',
  policyUserItem07_21:'（1）您在訪問和使用鼎新雲管家時違反了可接受的使用政策、本協議或適用的法律法規;',
  policyUserItem07_22:'（2）您違反了您向鼎新數智的付款義務;',
  policyUserItem07_23:'（3）您的訪問和對鼎新雲管家的使用可能會對鼎新雲管家、我們或第三方造成安全風險;',
  policyUserItem07_24:'（4）您對鼎新雲管家的使用可能會對鼎新雲管家的功能、可用性或操作產生不利影響;',
  policyUserItem07_25:'（5）根據相關法律法規或政府機構的要求;',
  policyUserItem07_26:'（6）您對鼎新雲管家的使用可能使鼎新雲管家承擔責任或監管法令遵循風險;',
  policyUserItem07_27:'（7）您可能侵犯第三方的智慧財產權;或',
  policyUserItem07_28:'（8）您已停止正常營業、或已破產、清算、解散或類似程序中。',
  policyUserItem07_29:'您承認並同意（a）暫停不會免除您就暫停期之前及暫停期間的服務費進行支付的義務;',
  policyUserItem07_210:'（b）您將無權因此類暫停得到任何退款或服務費用減免。',
  policyUserItem07_3:'7.3 終止。如果出現第8.2（1）至（8）節中描述的任何情況，我們也保留終止您訪問和使用鼎新雲管家的權利。',
  policyUserItem08:'8 全部協議',
  policyUserItem08_1:'8.1 協議關係。您在鼎新雲管家註冊帳戶時，已接受《鼎新雲管家用戶協議》。就您使用以鼎新雲管家名義提供的雲服務時，適用鼎新雲管家用戶協議。',
  policyUserItem08_2:'8.2 完整協議。本協議包括本協議的條款和條件，及以援引方式納入本協議的政策和文件。',
  policyUserItem08_3:'8.3 協議修改。鼎新雲管家保留修改本協議任何條款的權利，一旦本協議的內容發生變動，您可以在相關服務頁面查閱最新版本的協議條款， 修改後的條款一經公佈立即生效，鼎新雲管家無需單獨通知您。若您不同意上述修改，則可以選擇停止使用服務。 鼎新雲管家也可選擇透過其他適當方式（比如系統通知）向您通知修改內容,,如果不同意鼎新雲管家對本協議相關條款所做的修改， 您有權停止使用服務。如果您繼續使用服務，則視為您接受鼎新雲管家對本協議相關條款所做的修改。',
  policyUserItem09:'9 通知送達',
  policyUserItem09_1:'9.1 本協議項下鼎新雲管家對於您所有的通知均可透過網頁公告、電子郵件、系統通知主動聯繫、電子郵件、手機簡訊或常規的信件傳送等方式進行； 該等通知於發送之日視為已送達收件人。',
  policyUserItem09_2:'9.2 您對於鼎新雲管家的通知應當透過鼎新雲管家對外正式公佈的通訊地址、傳真號碼、電子郵件地址等聯繫資訊進行送達。',
  policyUserItem10:'10 其他規定',
  policyUserItem10_1:'10.1 如本協議中的任何條款因何種原因完全或部分無效或不具有執行力，本協議的其餘條款仍應有效並且有約束力。',
  policyUserItem10_2:'10.2 本協議中的標題僅為方便而設，在解釋本協議時應被忽略。',
  policyUserItem11:'11 法律適用',
  policyUserItem11_1:'11.1 本協議及其修訂本的有效性、履行和解釋均適用於中華民國之法律，任何爭議也僅適用中華民國法律。',
  policyUserItem11_2:'11.2 因本協議所引起的您與鼎新數智的任何糾紛或爭議，首先應本著友好協商原則進行解決，如果協商不成， 您在此完全同意將糾紛或爭議提交至鼎新數智股份有限公司註冊地有管轄權的地方法院透過訴訟解決。',
  policyUserItem12:'12 附則',
  policyUserItem12_1:'12.1 關係。雙方均為獨立締約方。本協議不為雙方創立合夥、合資、代理或雇傭關係。',
  policyUserItem12_2:'12.2 無第三方受益人。除非本協議另有明確規定，非本協議當事人不得執行本協議項下的任何條款。',
  policyUserItem12_3:'12.3 通知。我們可依照本協議規定透過網站、電子郵件、簡訊向您發出通知。我們透過網站而發出的通知將在發佈後生效， 透過電子郵件發佈的通知將在我們發出電子郵件時生效（無論您是否接收或讀取它），簡訊在發出時生效。您有責任及時更新您的電子郵件地址或電話號碼。',
  policyUserItem12_4:'12.4 不棄權。未能執行本協議的任何條款並不構成對此條款的放棄，亦不限制以後執行該等條款的權利。如果一方放棄追究任何一條違反本協議要求的條款， 不得視為放棄以後追究違反該條款的權利，也不得視為放棄追究違反任何其他條款的權利。',
  policyUserItem12_5:'12.5 可分割性。如果本協議任何條款被認定為無效或不可執行，本協議的其他條款將繼續有效。 任何無效或不可執行的條款將被替換為與本協議目的和意圖一致的另一條款。',
  policyUserItem12_6:'12.6 不可轉讓。未經鼎新數智事先書面同意，您不得轉讓或以其他方式將本協議的全部或部分轉讓給任何第三方，包括您的關聯方。 鼎新數智可能會在未經您同意的情況下向我們的關聯方轉讓或轉移本協議項下的任何權利或義務。在轉讓生效前，我們會透過網站通知或其他途徑告知您。',
}
export default ch_TW
